import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from '../../Utils/Server';
import Endpoints from '../../Constants/Endpoints';
import PageLayout from '../Layout/PageLayout';
import { DataTable, Card, StatusBadge, FormField, Select, Button } from '../UI';

const columns = [
  {
    name: 'When',
    selector: 'created_at',
    sortable: true,
    cell: (row) => new Date(row.created_at).toLocaleString(),
  },
  { name: 'Category', selector: 'category' },
  {
    name: 'Status',
    cell: (row) => <StatusBadge status={row.status}>{row.status}</StatusBadge>,
  },
  {
    name: 'Description',
    grow: 2,
    cell: (row) => (
      <span title={row.description}>
        {row.description && row.description.length > 80 ? row.description.slice(0, 80) + '…' : row.description}
      </span>
    ),
  },
  {
    name: 'Refund',
    cell: (row) => row.refund_cents > 0 ? `KES ${(row.refund_cents / 100).toFixed(2)}` : '—',
  },
  { name: '', right: true, cell: (row) => <Link to={`/complaints/${row.id}`}><Button size="sm" variant="outline">Details</Button></Link> },
];

export default function ComplaintsList() {
  const [list, setList] = useState([]);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const qs = status ? `?status=${status}` : '';
    fetchData(`${Endpoints.LIST_COMPLAINTS}${qs}`)
      .then((r) => r.json())
      .then((res) => {
        const raw = (res && res.data) || res || [];
        setList(Array.isArray(raw) ? raw : []);
        setLoading(false);
      });
  }, [status]);

  return (
    <PageLayout title="Complaints">
      <div style={{ maxWidth: 260, marginBottom: 16 }}>
        <FormField label="Status filter" flush>
          <Select value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">All</option>
            <option value="open">Open</option>
            <option value="triaged">Triaged</option>
            <option value="resolved">Resolved</option>
          </Select>
        </FormField>
      </div>
      <Card padded={false}>
        <DataTable
          columns={columns}
          data={list}
          progressPending={loading}
          noHeader={true}
        />
      </Card>
    </PageLayout>
  );
}
